export { default } from './GridOrdersEvent.vue'
